import { fg } from '@atlassian/jira-feature-gating';

const isJiraTimelineAnalyticsHarmonizationEnabled = {
	get(): boolean {
		return fg('jira_timeline_analytics_harmonization');
	},
};

export default isJiraTimelineAnalyticsHarmonizationEnabled;
